import React, { useEffect, useState } from 'react'
import Header from '../../Core/Header'
import { Section } from '../../Core/Section'
import { useParams } from 'react-router-dom';
import { getCustomizedRequestTestData } from '../../Services/Operations/ProductAPI';
import { useSelector } from 'react-redux';

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { baseURL } from '../../Services/api_endpoints';



const LineGraph = ({ data, showLeft, showRight, title }) => {
  return (
    <div style={{ marginBottom: "24px" }}>
      <p>{title}</p>

      <ResponsiveContainer width={(showLeft&&showRight)?500:300} height={200}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
            <XAxis
      dataKey="x"
      orientation="top"
    />
          <YAxis reversed  />
          <Tooltip />
          <Legend />

          {showLeft && (
            <Line
              type="monotone"
              dataKey="left"
              stroke="#28a745"
              connectNulls
              dot={{ r: 3 }}
            />
          )}

          {showRight && (
            <Line
              type="monotone"
              dataKey="right"
              stroke="#007bff"
              connectNulls
              dot={{ r: 3 }}
            />
          )}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};



const Graph = ({ graphData }) => {

const buildChartData = (graphData) => {
  if (!graphData?.left || !graphData?.right) return [];

  return graphData.left.x.map((xValue, index) => ({
    x: xValue,
    left: graphData.left.y[index],
    right: graphData.right.y[index],
  }));
};




  const chartData = buildChartData(graphData);

  if (!chartData.length) {
    return <p>No graph data available</p>;
  }

  return (
    <>
    <div style={{display:"flex"}}>
      {/* LEFT ONLY */}
      <LineGraph
        data={chartData}
        showLeft={true}
        showRight={false}
        title="Left Graph"
      />

      {/* RIGHT ONLY */}
      <LineGraph
        data={chartData}
        showLeft={false}
        showRight={true}
        title="Right Graph"
      /></div>

      {/* LEFT + RIGHT (COMBINED) */}
      <LineGraph
        data={chartData}
        showLeft={true}
        showRight={true}
        title="Left vs Right Graph"
      />
    </>
  );
};
const CustomizeTestData = () => {
     const { id } = useParams();
       const token = useSelector((state) => state.user.token);

       const [parsedGraphData,setParsedGraphdata]=useState([])
       const[selectedItem,setSelectedItem]=useState(null)

       const buildChartData = (graphData) => {
  if (!graphData?.left || !graphData?.right) return [];

  return graphData.left.x.map((xValue, index) => ({
    x: xValue,
    left: graphData.left.y[index],
    right: graphData.right.y[index],
  }));
};

     const handleGetCustomizedRequestData=async()=>{
      try {
        let parsedGraphData = null;

        const response=await getCustomizedRequestTestData(token)
        console.log("getCustomizedRequestTestData",response);
       
        let list=response.data.data.map(item=>{

          if (typeof item.graphDataJson === "string") {
    try {
      parsedGraphData = JSON.parse(item.graphDataJson);
    } catch (err) {
      console.error("Invalid JSON:", item.graphDataJson);
    }
  } else if (typeof item.graphDataJson === "object") {
    parsedGraphData = item.graphDataJson;
  }
        return {
    ...item,
    graphDataJson: parsedGraphData,
  };
      })


      console.log("graph data",list);
      
       
setParsedGraphdata(list)
        
      } catch (error) {
        console.log(error);
        
      }
     }

     useEffect(() => {
       handleGetCustomizedRequestData()
     }, [])


       const [currentPage, setCurrentPage] = useState(1);
         const itemsPerPage = 10;
         
         const indexOfLast = currentPage * itemsPerPage;
         const indexOfFirst = indexOfLast - itemsPerPage;
         
         const currentUsers = parsedGraphData.slice(indexOfFirst, indexOfLast);
     
  return (
   <div id="main_content">
        <Header/>
               <div className="page">
                   <Section />
                       <div className="section-body"
        style={{height: "80vh",width:"100%",}}
        >

          <p style={{fontSize:"22px",fontWeight:"600"}}>All test report of Customized Order</p>

             <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
                <thead>
                      <tr style={{textAlign:"center"}}>
                        <th>Id</th>
                        <th style={{textAlign:"center"}}>Answer Type</th>
                        <th style={{textAlign:"center"}}>Boolean Answer</th>
                        <th style={{textAlign:"center"}}>question Text</th>
                    
                        <th style={{textAlign:"center"}}>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {currentUsers?.map((user,index) => (
                        <tr key={user?.id}>
                          <td>{indexOfFirst+index+1}</td>
                         
                         
                          <td>
                            <span className="font-16">{` ${user?.answerType}`}</span>
                          </td>
                          
                          <td>{user?.booleanAnswer?"true":"false"}</td>
                          <td>{user?.questionText}</td>
                        
                          <td>
                            <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="View"
                              onClick={()=>setSelectedItem(user)}
                            >
                              <i className="fa fa-eye" />
                            </button>
                           
                          
                          </td>
                        </tr>
                      ))}
                    </tbody>

             </table>

                               <div className="pagination mt-3" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                             <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((prev) => prev - 1)}
    className="btn btn-primary btn-sm me-2"
  >
    Prev
                     </button>

                      <span> Page {currentPage} of {Math.ceil(parsedGraphData.length / itemsPerPage)} </span>

                  <button
    disabled={currentPage === Math.ceil(parsedGraphData.length / itemsPerPage)}
    onClick={() => setCurrentPage((prev) => prev + 1)}
    className="btn btn-primary btn-sm ms-2"
  >
    Next
               </button>
</div>

            {selectedItem &&
            <div style={{position:"fixed",top:"100px",right:'100px',zIndex:888,backgroundColor:"white",padding:"25px",borderRadius:"16px",border:"1px solid grey",width:"fit-content",height:"80vh",overflow:"hidden"}}>
             <p onClick={()=>setSelectedItem(null)}
             style={{position:"absolute",cursor:"pointer",top:"10px",right:"10px"}}>X</p>

             
              {
            selectedItem.answerType==='GRAPH_DATA'?
               (<div style={{height:"70vh",overflowY:"auto"}}>
                <Graph graphData={selectedItem.graphDataJson  } />

                <div style={{display:"flex",justifyContent:"space-between"}}>
                  <table style={{width:"20vw"}}>
                    <thead>
                      <tr>
                        {
               (selectedItem.graphDataJson.left.x).map(i=>(
                <th style={{fontSize:"10px",padding:"2px"}}>{i}</th>
               ))
                        }
                        
                      </tr>

                    </thead>

                    <tbody>
                      <tr>
                      {(selectedItem.graphDataJson.left.y).map(i=>(
                        <td style={{fontSize:"10px",padding:"2px"}}>
                          {i}
                        </td>
                      ))}</tr>
                    </tbody>
                  </table>

                      <p>Stimulus: <br/>Masking:</p>
                     
                      <table style={{width:"20vw"}}>
                    <thead>
                      <tr>
                        {
               (selectedItem.graphDataJson.right.x).map(i=>(
                <th style={{fontSize:"10px",padding:"2px"}}>{i}</th>
               ))
                        }
                 
                      </tr>

                    </thead>

                    <tbody>
                      <tr>
                      {(selectedItem.graphDataJson.right.y).map(i=>(
                        <td style={{fontSize:"10px",padding:"2px"}}>
                          {i}
                        </td>
                      ))}</tr>
                    </tbody>
                  </table>

                </div>
              </div>)
              : selectedItem.answerType==='IMAGE'?
              (
                <div>
                  <img style={{
                    width:"100px",
                    height:"100px"
                  }}
                  src={baseURL+selectedItem.imageUrl}/>
                </div>

              )
              :setSelectedItem(null)
             
             
              
            } </div>}


        </div>
                   </div>
    </div>
  )
}

export default CustomizeTestData
